export default {
    setCampusEvents(state, payload) {
        state.events = payload
    },
    setCampusProvinces(state, payload) {
        state.provinces = payload
    },
    setCampusEventsFilter(state, payload) {
       state.filters[payload.type] = payload.value
    },
    setSortType(state, payload) {
        state.sort = payload;
    }
}